export default __webpack_public_path__ + "static/media/tiktok.f301f659.svg";